module.exports = __webpack_public_path__ + "img/QRcode.6328351d.png";